import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-night font-sans text-white selection:bg-volt selection:text-carbon" data-id="element-0" data-mp="33mow1rfx4mpj">
      <noscript data-id="element-1" data-mp="38m1jadapbvsn">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38li6tc3tlzm0" />
      </noscript>

      <Hero data-id="element-3" data-mp="nuraocvicv35" />
      <main data-id="element-4" data-mp="nvar1p5ifbf2">
        <ProblemSection data-id="element-5" data-mp="nxn902b9pls4" />
        <SystemSection data-id="element-6" data-mp="sudmqizlo5ad" />
        <BonusesSection data-id="element-7" data-mp="stkm7zr8ic0o" />
        <BenefitsSection data-id="element-8" data-mp="st2kinlsz5ld" />
        <PricingSection data-id="element-9" data-mp="swglpsiqd8r8" />
        <GuaranteeSection data-id="element-10" data-mp="35yp0k2nrm1g" />
        <TestimonialsSection data-id="element-11" data-mp="356sn718lka4" />
        <FAQSection data-id="element-12" data-mp="38kvegdtbvi3" />
        <FinalCTA data-id="element-13" data-mp="3uct3bjmdin0h" />
      </main>
      <Footer data-id="element-14" data-mp="3ubrfeek9e61c" />
      <PurchasePopup data-id="element-15" data-mp="3ubztg9s4bhe4" />
    </div>;
}